import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    requestAnimationFrame(() => {
      const editor = this.element.querySelector('trix-editor')
      if (editor) editor.focus()
    })
  }
}
